export class CostReviewHeatingPlant {
  numberOfBoilers!: number;
  manufacturerBoilers!: string;
  driversBoilers!: number;
  boilersControlsFurnishedBy!: number;
  boilersControlsInstalledBy!: number;
  boilersControlsWiredBy!: number;
  numberOfTowers!: number;
  manufacturerTowers!: string;
  driversTowers!: number;
  towersControlsFurnishedBy!: number;
  towersControlsInstalledBy!: number;
  towersControlsWiredBy!: number;
  numberOfPumps!: number;
  manufacturerPumps!: string;
  driversPumps!: number;
  pumpsSensorsFurnishedBy!: number;
  pumpsSensorsInstalledBy!: number;
  pumpsSensorsWiredBy!: number;
  isHeatingPlantApplicable!: boolean;
}
